import { render, staticRenderFns } from "./Recycle.vue?vue&type=template&id=0b8e085d&scoped=true"
import script from "./Recycle.vue?vue&type=script&lang=js"
export * from "./Recycle.vue?vue&type=script&lang=js"
import style0 from "./Recycle.vue?vue&type=style&index=0&id=0b8e085d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8e085d",
  null
  
)

export default component.exports